import { useMemo } from "react";
import { PartnerContactColumn } from "./types";
import { PartnerStatus } from "../types";
import { partnerStatusColors } from "./helpers";
import { DataTableFilter } from "@/components/controls/DataTableFilters/DataTableFilters";
import IconContainer from "@/components/ui/icon-container";
import { Bullet } from "@dreamhub/designsystem/icons";
import { getCountryDisplayName } from "@/utils/countries";
import { getCurrentLocale } from "@/utils/locale";

interface UsePartnerContactFilterOptionsArgs {
  countryValues: string[];
  stateRegionValues: string[];
}

export const usePartnerContactFilterOptions = ({
  countryValues,
  stateRegionValues
}: UsePartnerContactFilterOptionsArgs) =>
  useMemo<DataTableFilter[]>(
    () => [
      { key: "firstName", filterType: { type: "text" } },
      { key: "lastName", filterType: { type: "text" } },
      { key: PartnerContactColumn.JOB_TITLE, filterType: { type: "text" } },
      { key: "email", filterType: { type: "text" } },
      { key: PartnerContactColumn.CITY, filterType: { type: "text" } },
      { key: PartnerContactColumn.POSTAL_CODE, filterType: { type: "text" } },
      {
        key: PartnerContactColumn.STATUS,
        excludeNoValue: true,
        filterType: {
          type: "enum",
          values: {
            enumType: PartnerStatus,
            entityType: "partnercontacts",
            valueType: "statusValues",
            getIcon: (status: PartnerStatus) => (
              <IconContainer
                size="xs"
                style={{ color: partnerStatusColors[status] }}
              >
                <Bullet />
              </IconContainer>
            )
          }
        }
      },
      {
        key: PartnerContactColumn.COUNTRY,
        filterType: {
          type: "map",
          values: countryValues.map((value: string) => ({
            value,
            label: getCountryDisplayName(value, getCurrentLocale())
          })),
          sort: true
        }
      },
      {
        key: PartnerContactColumn.STATE_REGION,
        filterType: {
          type: "map",
          values: stateRegionValues.map((value: string) => ({
            value,
            label: value
          })),
          sort: true
        }
      }
    ],
    [countryValues, stateRegionValues]
  );
